import type { DriveStep } from 'driver.js';
import type { Translations } from '../i18n';

export function getTourSteps(t: Translations): DriveStep[] {
  return [
    {
      element: '[data-tour="nav-dashboard"]',
      popover: {
        title: t.tour.dashboard.title,
        description: t.tour.dashboard.description,
      },
    },
    {
      element: '[data-tour="nav-campo-lotes"]',
      popover: {
        title: t.tour.camposLotes.title,
        description: t.tour.camposLotes.description,
      },
    },
    {
      element: '[data-tour="nav-tareas"]',
      popover: {
        title: t.tour.tareas.title,
        description: t.tour.tareas.description,
      },
    },
    {
      element: '[data-tour="nav-insumos"]',
      popover: {
        title: t.tour.insumos.title,
        description: t.tour.insumos.description,
      },
    },
    {
      element: '[data-tour="nav-finanzas"]',
      popover: {
        title: t.tour.finanzas.title,
        description: t.tour.finanzas.description,
      },
    },
  ];
}
